module.exports = __webpack_public_path__ + "static/img/indexBook.1cf561d.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexBook.png
// module id = 9SXg
// module chunks = 3